export const success = {
  'Day <1>{{date}}</1> at <3>{{time}}</3>':
    'Día <1>{{date}}</1> a las <3>{{time}}</3>',
  'Go back to home': 'Volvé al inicio',
  Success: 'Éxito',
  'Your session was scheduled!': '¡Tu sesión fue agendada!',
};
